// src/pages/ContactPage.js
import React from 'react';

function ContactPage() {
  return (
    <div className="pricing-page" style={{textAlign:'left'}}>
      <h2>Contact Us</h2>
      <p>We’d love to hear from you. Reach us at <a href="mailto:support@complianceguardian.cloud">support@complianceguardian.cloud</a>.</p>
      <p>For enterprise inquiries, please include your organization name and tenant ID.</p>
    </div>
  );
}

export default ContactPage;
